import { DateTime } from "luxon";

export const LAST_30_DAYS_LABEL = "Last 30 days";

export type Last30DaysPeriod = {
  start: DateTime;
  end: DateTime;
  label: typeof LAST_30_DAYS_LABEL;
};

/** Rolling 30-day window ending on the reference day (inclusive). */
export function buildLast30DaysPeriod(reference: DateTime = DateTime.now()): Last30DaysPeriod {
  const end = reference.endOf("day");
  const start = end.minus({ days: 29 }).startOf("day");

  return {
    start,
    end,
    label: LAST_30_DAYS_LABEL
  };
}

export function last30DaysQueryVariables(period: Last30DaysPeriod): {
  startDateTime: string;
  endDateTime: string;
} {
  return {
    startDateTime: period.start.toUTC().toISO() ?? "",
    endDateTime: period.end.toUTC().toISO() ?? ""
  };
}
